import { useAuth, checkPermissions, Icon } from '@artprov/design-system';
import { NoRoleAccessFallback } from './NoRoleAccessFallback.jsx';
import PropTypes from 'prop-types';

/**
 * Componente reutilizable para proteger rutas o secciones por roles de Keycloak.
 * Soporta lógica OR (alguno de los roles) o AND (todos los roles).
 *
 * @param {string[]} roles - Array de nombres de roles requeridos.
 * @param {boolean} requireAll - Si es true, requiere TODOS los roles. Si es false, al menos uno.
 * @param {ReactNode} children - Contenido a renderizar si tiene acceso.
 * @param {ReactNode} fallback - Contenido alternativo si no tiene acceso. Por defecto muestra NoRoleAccessFallback.
 */
export function RoleGuard({
    roles = [],
    requireAll = false,
    children,
    fallback = null,
}) {
    const { loading } = useAuth();


    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Icon size="extra-large" variant="loading" />
            </div>
        );
    }

    const hasRoleAccess = checkPermissions(roles, { requireAll });

    if (!hasRoleAccess) {
        return fallback || <NoRoleAccessFallback />;
    }

    return children;
}

RoleGuard.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string),
    requireAll: PropTypes.bool,
    children: PropTypes.node,
    fallback: PropTypes.node,
};
